import type { ProfileModuleDto } from '@up2stay/up2promo-api-client';

import {
  DEFAULT_MODULE_TYPE_LABELS,
  MODULE_TYPE_DEFAULT_HEADINGS,
} from './public-profile-module-copy';

export function getModuleLabel(
  type: string,
  labels?: Record<string, string> | null,
): string {
  const fromDict = labels?.[type]?.trim();
  if (fromDict) return fromDict;
  return DEFAULT_MODULE_TYPE_LABELS[type] ?? String(type);
}

function isDefaultModuleHeading(
  type: string,
  stored: string,
  fallbackLabel: string,
): boolean {
  const normalized = stored.trim().toLowerCase();
  if (!normalized) return true;
  const known = MODULE_TYPE_DEFAULT_HEADINGS[type] ?? [];
  const candidates = [fallbackLabel, DEFAULT_MODULE_TYPE_LABELS[type], ...known]
    .map((label) => label?.trim().toLowerCase())
    .filter((label): label is string => Boolean(label));
  return candidates.includes(normalized);
}

export function getModuleSectionTitle(
  module: ProfileModuleDto,
  fallbackLabel: string,
): string {
  const custom = (module.config?.sectionTitle as string)?.trim();
  if (
    !custom ||
    isDefaultModuleHeading(module.type ?? '', custom, fallbackLabel)
  ) {
    return fallbackLabel;
  }
  return custom;
}
